// Constants
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
// Services
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "SharingApp/ts/services/sharing.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component";
import * as i7 from "FoldersApp/features/folders-shared/set-view-root-folder/set-view-root-folder.directive";
const _c0 = a0 => ({ "visible-md-flex": a0 });
const _c1 = a0 => ({ "view-root": a0 });
const _forTrack0 = ($index, $item) => $item.id;
function FolderBreadcrumbComponent_For_5_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "a", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", "...")("folderId", item_r1.id);
} }
function FolderBreadcrumbComponent_For_5_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "a", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", item_r1.name)("folderId", item_r1.id);
} }
function FolderBreadcrumbComponent_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderBreadcrumbComponent_For_5_Conditional_0_Template, 2, 2, "li", 2)(1, FolderBreadcrumbComponent_For_5_Conditional_1_Template, 2, 2, "li", 2);
} if (rf & 2) {
    const ɵ$index_9_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ɵ$index_9_r2 === 0 && ctx_r2.folderableCollectionService.viewRootFolder.ancestors.length === ctx_r2.maxDisplayedAncestors ? 0 : 1);
} }
function FolderBreadcrumbComponent_Conditional_6_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", ctx_r2.sharingService.getSharingTooltipMessage(ctx_r2.folderableCollectionService.viewRootFolder));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function FolderBreadcrumbComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "div", 5);
    i0.ɵɵtemplate(2, FolderBreadcrumbComponent_Conditional_6_Conditional_2_Template, 2, 4, "div", 6);
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵelement(4, "ycn-folder-operations-dropdown", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", ctx_r2.folderableCollectionService.viewRootFolder.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.sharingService.isSharedWithOthers(ctx_r2.folderableCollectionService.viewRootFolder) ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("item", ctx_r2.folderableCollectionService.viewRootFolder)("folderIsDisabled", false)("resourceType", ctx_r2.FolderItemType.FOLDER)("resourceTypeDescription", "folder")("listItemView", false)("ancestorFolderId", ctx_r2.ancestorFolderId);
} }
/**
 * Component for breadcrumb of folder links.
 * - Show the current folder and its ancestors (if there are any).
 * - Used to navigate to a parent folder and see how deep in the folder hierarchy the user is.
 *
 * Example Format:
 * - My YCharts > ... > Folder 3 > Folder 4 > Folder 5
 */
export class FolderBreadcrumbComponent {
    get ancestorFolderId() {
        const ancestors = this.folderableCollectionService.viewRootFolder?.ancestors;
        return ancestors === undefined || ancestors.length <= 0 ? null : ancestors[ancestors.length - 1].id;
    }
    constructor(folderableAppConfig, folderableCollectionService, sharingService) {
        this.folderableAppConfig = folderableAppConfig;
        this.folderableCollectionService = folderableCollectionService;
        this.sharingService = sharingService;
        // The maximum number of ancestor folders that can be displayed in the breadcrumb.
        // Note: this does not include My YCharts.
        this.maxDisplayedAncestors = 3;
        this.FolderItemType = FolderableType;
        this.displayFlex = false;
    }
}
FolderBreadcrumbComponent.ɵfac = function FolderBreadcrumbComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderBreadcrumbComponent)(i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG), i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.SharingService)); };
FolderBreadcrumbComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderBreadcrumbComponent, selectors: [["ycn-folder-breadcrumb"]], inputs: { displayFlex: "displayFlex" }, standalone: false, decls: 7, vars: 9, consts: [[1, "mr-1", 3, "ngClass"], [1, "file-path"], [1, "file-path-item"], ["href", "javascript:void(0)", "ycn-set-view-root-folder", "", 1, "file-path-title", 3, "ngClass", "textContent", "folderId"], ["href", "javascript:void(0)", "ycn-set-view-root-folder", "", 1, "file-path-title", 3, "textContent", "folderId"], [1, "file-path-title", "view-root", 3, "textContent"], ["ycnTooltip", "", 1, "filepath-title", "btn", "btn-circle", "btn-share", "btn-transparent", "btn-xs", "ml-1", "btn-transparent3", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [1, "dropdown", "ml-1"], [3, "item", "folderIsDisabled", "resourceType", "resourceTypeDescription", "listItemView", "ancestorFolderId"], ["ycnIcon", "", 3, "name"]], template: function FolderBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ul", 1)(2, "li", 2);
        i0.ɵɵelement(3, "a", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵrepeaterCreate(4, FolderBreadcrumbComponent_For_5_Template, 2, 1, null, null, _forTrack0);
        i0.ɵɵtemplate(6, FolderBreadcrumbComponent_Conditional_6_Template, 5, 8, "li", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.displayFlex));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, (ctx.folderableCollectionService.viewRootFolder == null ? null : ctx.folderableCollectionService.viewRootFolder.id) === null))("textContent", ctx.folderableAppConfig.itemNamePlural || "My YCharts")("folderId", null);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.folderableCollectionService.viewRootFolder == null ? null : ctx.folderableCollectionService.viewRootFolder.ancestors);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.viewRootFolder && ctx.folderableCollectionService.viewRootFolder.id ? 6 : -1);
    } }, dependencies: [i3.NgClass, i4.IconDirective, i5.TooltipDirective, i6.FolderOperationsDropdownComponent, i7.SetViewRootFolderDirective], encapsulation: 2 });
